// removed by extract-text-webpack-plugin
module.exports = {"footer":"Uumdi_9SX_al7wo7CNQgG","footerThemeDefault":"_3tnjMu8YslMff6E_S8NOUf","footerThemePrimary":"_119vtWKxgW1PZbUOdyYDyQ","footerThemeDark":"_3bvraBa9WMEzLAB0jI-Hyl","logo":"_1rSkgZTo6uu7IKOcufBfXO"};


//////////////////
// WEBPACK FOOTER
// ./node_modules/quark-gui/src/modules/02-organisms/global/footer.scss
// module id = 118
// module chunks = 0